import { TemplateIdentifier } from '@candu-ai/first-mate/api';

export const TEMPLATE_CONTENT_URI = '/api/first-mate/template-content';

export type TemplateContentRequest = {
  prompt: string;
  template: TemplateIdentifier;
};

interface TemplateData {
  [key: string]: string;
}

export type TemplateContent = {
  data: TemplateData;
  templateId: number;
  documentId: number;
};
